import { CiClock2 } from "react-icons/ci"
import { FaPhone } from "react-icons/fa"
import { IoCalendarClear, IoCalendarOutline, IoMailOutline } from "react-icons/io5"
import { TfiDownload } from "react-icons/tfi";


export const GeneralTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20 flex justify-between w-full max-w-[1400px]">
            <div className="flex flex-col gap-5">
                <p className="justify-start text-[#3c3c3c] text-xl font-semibold font-['Inter']">
                    Course : B.Tech Specialization in Health Informatics
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-semibold font-['Inter']">
                    Full name : Raj Anadkat
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">
                    Mother’s name : Leela bai Anadkat
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">
                    Father’s name : Mukesh Anadkat
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">
                    Course Start Date : 17 Jan 2023
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">
                    Course End Date : 17 Jan 2025
                </p>
                <p className="justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">
                    Batch : 3CO-JVY
                </p>
            </div>
            <div className="w-[635px] h-[223px] flex gap-[54px] p-[17px] bg-white rounded-[5px] border border-[#d9d9d9]">
                <div className="flex flex-col gap-[10px]">
                    <h2 className="justify-start text-[#3c3c3c] text-xl font-semibold font-['Inter']">
                        Center Details
                    </h2>
                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">
                        Pincode : 302021
                        <br />
                        District : Jaipur
                        <br />
                        State : Rajasthan
                    </p>
                    <p className="w-[265px] justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">
                        Address : Plot no. 116, Lane number 4, Rathore nagar, Vaishali
                        nagar , Jaipur
                    </p>
                </div>
                <div className="flex flex-col gap-[10px]">
                    <h2 className="justify-start text-[#3c3c3c] text-xl font-semibold font-['Inter']">
                        Center Contact
                    </h2>
                    <p className="flex gap-1 items-center text-[#3c3c3c] text-base font-normal font-['Inter']">
                        <span>
                            <FaPhone />
                        </span>{" "}
                        <span>12345 69870</span>
                    </p>
                    <p className="flex gap-1 items-center text-[#3c3c3c] text-base font-normal font-['Inter']">
                        <span>
                            <IoMailOutline />
                        </span>{" "}
                        <span>hanumannagar.center@tipsg.in</span>
                    </p>
                </div>
            </div>
        </div>

        <div className="flex w-full pb-40 max-w-[1400px] px-10 justify-between">
            {Array.from({ length: 4 }, (_, index) => (
                <div className="flex flex-col gap-[13px]">
                    <h3 className="justify-start text-[#3c3c3c] text-xl font-semibold font-['Inter']">
                        Attendance
                    </h3>
                    <div className="border border-[#ECECEC] p-[15px] rounded-[5px] ">
                        <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">
                            Total Classes : 145
                        </p>
                        <p className="justify-start text-[#60df6f] text-base font-semibold font-['Inter']">
                            Attended : 120
                        </p>
                        <p className="justify-start text-[#f93333] text-base font-semibold font-['Inter']">
                            Missed : 25
                        </p>
                        <button className="w-[282px] h-[42px] relative">
                            <span className="left-[100px] top-[13px] absolute justify-start text-white text-sm font-normal font-['Inter']">
                                View Details
                            </span>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    </>
}

export const QuizTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20  w-full max-w-[1400px]">
            <div className="flex gap-10">
                <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">Total Quizzes : 245</p>
                <p className="justify-start text-[#6b6b6b] text-base font-semibold font-['Inter']">Attempted : 120</p>
                <p className="justify-start text-[#9e9e9e] text-base font-semibold font-['Inter']">Unattempt : 125</p>
                <p className="justify-start text-[#55de64] text-base font-semibold font-['Inter']">Passed : 25</p>
                <p className="justify-start text-[#f93333] text-base font-semibold font-['Inter']">Failed : 25</p>
            </div>

            <div className="flex flex-wrap gap-[30px] mt-7">
                {
                    Array.from({ length: 8 }, (_, index) => (
                        <div key={index} className="py-11 px-6 border border-[#E6E6E6] rounded-[5px]" >
                            <h3 className="w-[310px] justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">Articulate structure of C++ and Java in Semester 1</h3>
                            <p className="justify-start mt-5 mb-4 text-[#9a9a9a] text-base font-normal font-['Inter']">Subject : Network Engineering</p>
                            <div className="flex gap-10">
                                <div className="flex gap-2 items-center">
                                    <span><IoCalendarClear /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">3-01-2023</p>
                                </div>
                                <div className="flex gap-2 items-center">
                                    <span><CiClock2 /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">12:30 AM - 01:40 PM</p>
                                </div>
                            </div>

                            <p className="flex gap-5 mt-[30px] mb-4 ">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Passing Percentage</span>
                                <span className="justify-start text-[#3c70f5] text-sm font-normal font-['Inter']">70%</span>
                            </p>
                            <p className="flex gap-5 mb-[26px]">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Scored Percentage</span>
                                <span className="justify-start  text-[#f93333] text-sm font-normal font-['Inter']">50%</span>
                            </p>

                            <button className="w-[351px] bg-[#3d70f5] rounded h-[42px] relative">
                                <span className=" text-white text-sm font-normal font-['Inter']">View Details</span>
                            </button>

                        </div>
                    ))
                }
            </div>
        </div>
    </>
}
export const ExamsTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20  w-full max-w-[1400px]">
            <div className="flex gap-10">
                <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">Total Exams : 245</p>
                <p className="justify-start text-[#6b6b6b] text-base font-semibold font-['Inter']">Attempted : 120</p>
                <p className="justify-start text-[#9e9e9e] text-base font-semibold font-['Inter']">Unattempt : 125</p>
                <p className="justify-start text-[#55de64] text-base font-semibold font-['Inter']">Passed : 25</p>
                <p className="justify-start text-[#f93333] text-base font-semibold font-['Inter']">Failed : 25</p>
            </div>

            <div className="flex flex-wrap gap-[30px] mt-7">
                {
                    Array.from({ length: 8 }, (_, index) => (
                        <div key={index} className="py-11 px-6 border border-[#E6E6E6] rounded-[5px]" >
                            <h3 className="w-[310px] justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">Articulate structure of C++ and Java in Semester 1</h3>
                            <p className="justify-start mt-5 mb-4 text-[#9a9a9a] text-base font-normal font-['Inter']">Subject : Network Engineering</p>
                            <div className="flex gap-10">
                                <div className="flex gap-2 items-center">
                                    <span><IoCalendarClear /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">3-01-2023</p>
                                </div>
                                <div className="flex gap-2 items-center">
                                    <span><CiClock2 /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">12:30 AM - 01:40 PM</p>
                                </div>
                            </div>

                            <p className="flex gap-5 mt-[30px] mb-4 ">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Passing Percentage</span>
                                <span className="justify-start text-[#3c70f5] text-sm font-normal font-['Inter']">70%</span>
                            </p>
                            <p className="flex gap-5 mb-[26px]">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Scored Percentage</span>
                                <span className="justify-start  text-[#f93333] text-sm font-normal font-['Inter']">50%</span>
                            </p>

                            <button className="w-[351px] bg-[#3d70f5] rounded h-[42px] relative">
                                <span className=" text-white text-sm font-normal font-['Inter']">View Details</span>
                            </button>

                        </div>
                    ))
                }
            </div>
        </div>
    </>
}

export const AssignmentTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20  w-full max-w-[1400px]">
            <div className="flex gap-10">
                <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">Total Assignment : 245</p>
                <p className="justify-start text-[#6b6b6b] text-base font-semibold font-['Inter']">Attempted : 120</p>
                <p className="justify-start text-[#9e9e9e] text-base font-semibold font-['Inter']">Unattempt : 125</p>
                <p className="justify-start text-[#55de64] text-base font-semibold font-['Inter']">Passed : 25</p>
                <p className="justify-start text-[#f93333] text-base font-semibold font-['Inter']">Failed : 25</p>
            </div>

            <div className="flex flex-wrap gap-[30px] mt-7">
                {
                    Array.from({ length: 8 }, (_, index) => (
                        <div key={index} className="py-11 px-6 border border-[#E6E6E6] rounded-[5px]" >
                            <h3 className="w-[310px] justify-start text-[#3c3c3c] text-xl font-medium font-['Inter']">Articulate structure of C++ and Java in Semester 1</h3>
                            <p className="justify-start mt-5 mb-4 text-[#9a9a9a] text-base font-normal font-['Inter']">Subject : Network Engineering</p>
                            <div className="flex gap-10">
                                <div className="flex gap-2 items-center">
                                    <span><IoCalendarClear /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">3-01-2023</p>
                                </div>
                                <div className="flex gap-2 items-center">
                                    <span><CiClock2 /></span>
                                    <p className="justify-start text-[#3c3c3c] text-base font-normal font-['Inter']">12:30 AM - 01:40 PM</p>
                                </div>
                            </div>

                            <p className="flex gap-5 mt-[30px] mb-4 ">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Passing Percentage</span>
                                <span className="justify-start text-[#3c70f5] text-sm font-normal font-['Inter']">70%</span>
                            </p>
                            <p className="flex gap-5 mb-[26px]">
                                <span className="justify-start text-[#3c3c3c] text-sm font-normal font-['Inter']">Scored Percentage</span>
                                <span className="justify-start  text-[#f93333] text-sm font-normal font-['Inter']">50%</span>
                            </p>

                            <button className="w-[351px] bg-[#3d70f5] rounded h-[42px] relative">
                                <span className=" text-white text-sm font-normal font-['Inter']">View Details</span>
                            </button>

                        </div>
                    ))
                }
            </div>
        </div>
    </>
}
export const ClassesTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20  w-full max-w-[1400px]">
            <div className="flex gap-10">
                <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">Total Classes : 245</p>
                <p className="justify-start text-[#55de64] text-base font-semibold font-['Inter']">Present : 25</p>
                <p className="justify-start text-[#f93333] text-base font-semibold font-['Inter']">Absent : 25</p>
            </div>

            <div className="flex flex-wrap gap-[30px] mt-7">
                {
                    Array.from({ length: 8 }, (_, index) => (
                        <div key={index} className="border border-[#E6E6E6] rounded-[5px] py-[27px] px-[25px]">
                            <h3 className="w-[349px] justify-start text-black text-2xl font-semibold font-['Inter']">How to Make an Array and it’s Types in C++</h3>
                            <div className="w-[152px] rounded-[5px] border py-2 px-2.5 mt-[18px] mb-[15px] border-[#d3d3d3]" >
                                <p className=" text-[#979797] text-base font-medium font-['Inter']">Batch 3CO - JVY</p>
                            </div>
                            <div className="flex gap-6">
                                <p className="flex items-center gap-2 text-[#979797] text-base font-medium font-['Inter']">
                                    <span><CiClock2 /></span>
                                    12:40 P:M
                                </p>
                                <p className="flex items-center gap-2 text-[#979797] text-base font-medium font-['Inter']">
                                    <span><IoCalendarOutline /></span>
                                    03 Jan 2023
                                </p>
                            </div>
                            <div className="w-44  py-2 bg-[#ddfff2] mt-5 rounded-[5px]" >
                                <p className="justify-start text-[#3edb4e] text-base text-center font-normal font-['Inter']">Status : Present</p>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    </>
}

export const FeesTab = () => {
    return <>
        <div className="px-10 pt-[30px] pb-20 flex gap-[58px] w-full max-w-[1500px]">
            <div className="flex flex-col gap-10 w-full max-w-[315px]">
                <div className="w-[315px] h-[174px] relative bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-black overflow-hidden">
                    <p className="left-[23px] top-[33px] absolute justify-start text-[#424242] text-2xl font-normal font-['Inter']">Total Amount</p>
                    <p className="left-[21px] top-[80px] absolute text-center justify-start text-[#424242] text-[40px] font-semibold font-['Inter']">₹ 1,59,698</p>
                </div>
                <div className="w-[315px] h-[174px] relative bg-[#ffefef] rounded-[10px] outline outline-1 outline-offset-[-1px] outline-black overflow-hidden">
                    <p className="left-[23px] top-[33px] absolute justify-start text-[#424242] text-2xl font-normal font-['Inter']">Amount Remaining</p>
                    <p className="left-[21px] top-[80px] absolute text-center justify-start text-[#424242] text-[40px] font-semibold font-['Inter']">₹ 1,59,698</p>
                </div>
            </div>
            <div className="w-full grid grid-cols-3 gap-5">
                <div className="py-[30px] px-6 border border-[#000000] w-full rounded-[10px]">
                    <h2 className="justify-between flex items-center text-[#424242] text-2xl font-semibold font-['Inter']">Payment History <span className="inline-flex py-[10px] px-[13px] border border-[#D1D1D1] rounded-[5px]"><TfiDownload /></span></h2>
                    <div className="grid grid-cols-[1fr_1fr_auto] gap-1 mt-[27px]">
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Date</p>
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Amount</p>
                        <span className="inline-flex w-3"></span>
                    </div>

                    <div className="flex flex-col gap-5 mt-5 ">
                        {
                            Array.from({ length: 5 }, (_, index) => (
                                <div key={index} className="py-5 px-[13px] w-full grid grid-cols-[1fr_1fr_auto] gap-1 mx-auto border border-[#D1D1D1] rounded-[5px]">
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">3 Mar 2023</p>
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">INR 52,526</p>
                                    <span className="inline-flex w-3"><TfiDownload /></span>
                                </div>
                            ))
                        }
                    </div>

                </div>
                <div className="py-[30px] px-6 border border-[#000000] w-full rounded-[10px]">
                    <h2 className="justify-between flex items-center text-[#424242] text-2xl font-semibold font-['Inter']">Payment Expected

                    </h2>
                    <div className="grid grid-cols-2 gap-5 mt-[27px]">
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Date</p>
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Amount</p>
                    </div>

                    <div className="flex flex-col gap-5 mt-5 ">
                        {
                            Array.from({ length: 5 }, (_, index) => (
                                <div key={index} className="py-5 px-[13px] w-full grid grid-cols-2 gap-5 border border-[#D1D1D1] rounded-[5px]">
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">3 Mar 2023</p>
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">INR 52,526</p>
                                </div>
                            ))
                        }
                    </div>

                </div>
                <div className="py-[30px] px-6 border border-[#000000] w-full rounded-[10px]">
                    <h2 className="justify-between flex items-center text-[#424242] text-2xl font-semibold font-['Inter']">Default Payments
                    </h2>
                    <div className="grid grid-cols-2 gap-5 mt-[27px]">
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Date</p>
                        <p className="justify-start text-[#424242] text-base font-medium font-['Inter']">Amount</p>
                    </div>

                    <div className="flex flex-col gap-5 mt-5 ">
                        {
                            Array.from({ length: 5 }, (_, index) => (
                                <div key={index} className="py-5 px-[13px] w-full grid grid-cols-2 gap-5 border border-[#D1D1D1] rounded-[5px]">
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">3 Mar 2023</p>
                                    <p className="justify-start text-[#424242] text-base font-normal font-['Inter']">INR 52,526</p>
                                </div>
                            ))
                        }
                    </div>

                </div>
            </div>
        </div>
    </>
}